module.exports = __webpack_public_path__ + "media/images/iconClose-25e0ac97a82679a9f7da97aef06b425e.png";